import { render, staticRenderFns } from "./DadosProfissionais.vue?vue&type=template&id=600e5f9a&scoped=true"
import script from "./DadosProfissionais.vue?vue&type=script&lang=js"
export * from "./DadosProfissionais.vue?vue&type=script&lang=js"
import style0 from "./DadosProfissionais.vue?vue&type=style&index=0&id=600e5f9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600e5f9a",
  null
  
)

export default component.exports